/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ENumericSearchType } from './ENumericSearchType';
import {
    ENumericSearchTypeFromJSON,
    ENumericSearchTypeFromJSONTyped,
    ENumericSearchTypeToJSON,
} from './ENumericSearchType';

/**
 * 
 * @export
 * @interface ENumericSearchTypeInt64NullableCombinableCriteria
 */
export interface ENumericSearchTypeInt64NullableCombinableCriteria {
    /**
     * 
     * @type {ENumericSearchType}
     * @memberof ENumericSearchTypeInt64NullableCombinableCriteria
     */
    searchMode?: ENumericSearchType;
    /**
     * 
     * @type {number}
     * @memberof ENumericSearchTypeInt64NullableCombinableCriteria
     */
    value?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ENumericSearchTypeInt64NullableCombinableCriteria
     */
    secondaryValue?: number | null;
}

/**
 * Check if a given object implements the ENumericSearchTypeInt64NullableCombinableCriteria interface.
 */
export function instanceOfENumericSearchTypeInt64NullableCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ENumericSearchTypeInt64NullableCombinableCriteriaFromJSON(json: any): ENumericSearchTypeInt64NullableCombinableCriteria {
    return ENumericSearchTypeInt64NullableCombinableCriteriaFromJSONTyped(json, false);
}

export function ENumericSearchTypeInt64NullableCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ENumericSearchTypeInt64NullableCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : ENumericSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function ENumericSearchTypeInt64NullableCombinableCriteriaToJSON(value?: ENumericSearchTypeInt64NullableCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': ENumericSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

